import { getMessage } from '@tcc/i18n';
import { PlantingEvents, PlantingEventWithDefaults, PlantingProducts } from '../../types';
import { LOCALE_GROUPS, POPULATION_WEIGHT_UNITS } from '../../constants/units';
import { buildSeasonTagWithWildcards } from '../../utils/seasonUtils';
import { LegacyCropsMap } from '../types/LegacyCropsMap';
import {
  UapiPlantingEventByCropSeason,
  UapiSeedProductEvent
} from '../../graphql/sdk';

function adaptSeedProducts(seedProductEvents: UapiSeedProductEvent[]): PlantingProducts {
  return seedProductEvents.map(({seedProduct, plantedArea, plantingLocalDate}) => {
    const productId =  seedProduct?.id ? seedProduct.id : 'unknown';
    const productName = seedProduct?.name ? seedProduct.name : getMessage('legend.unknown');

    return {
      id: productId,
      name: productName,
      plantedArea: plantedArea.v,
      unit: plantedArea.u || 'ha',
      date: plantingLocalDate,
    };
  });
}

function adaptPlantingEvent({
  averageSeedingRate,
  firstPlantingLocalDate,
  plantedArea,
  seedProductEvents
}: UapiPlantingEventByCropSeason): PlantingEventWithDefaults {
   const averageSeedingRateLocaleGroup = averageSeedingRate && averageSeedingRate.u === POPULATION_WEIGHT_UNITS.PLANTING_ABBREVIATED
        ? LOCALE_GROUPS.POPULATION_WEIGHT
        : LOCALE_GROUPS.POPULATION

  return {
    date: firstPlantingLocalDate,
    seedProducts: adaptSeedProducts(seedProductEvents),
    area: plantedArea ? {
      q: plantedArea.v,
      u: plantedArea.u || 'ha'
    } : { q: 0, u: 'ha' },
    population: averageSeedingRate ? {
      q: averageSeedingRate.v,
      u: averageSeedingRate.u || 'seed/ha',
      localeGroup: averageSeedingRateLocaleGroup
    } : { q: 0, u: 'seed/ha', localeGroup: averageSeedingRateLocaleGroup }
  }
}
// response.data.field.plantingEventAggregates?.eventsByCropSeason
export function adaptUapiPlantingResponse(
  response: UapiPlantingEventByCropSeason[],
  cropsMaps: LegacyCropsMap
): PlantingEvents {
  const defaultResult: PlantingEvents = {
    events: {},
    plantingSeasons: [],
  };

  return response.reduce((accum, currentPlantingEvent) => {
    const { seasonYear, seasonName, crop} = currentPlantingEvent;

    const legacySeasonCode = buildSeasonTagWithWildcards({
      year: seasonYear,
      season: seasonName,
      cropCode: cropsMaps[crop.id]
    });

    if (!accum.events[legacySeasonCode]) {
      return {
        ...accum,
        events: {
          ...accum.events,
          [legacySeasonCode]: adaptPlantingEvent(currentPlantingEvent),
        },
        plantingSeasons: [
          ...accum.plantingSeasons,
          { season: legacySeasonCode }
        ]
      };
    }

    return accum;
  }, defaultResult);
}